/*
* here is an example class. You can use this example as a guide
 */

class Accordion {
    constructor() {
        // add global class identifier
        this.class = {
            accordion: '.accordion',
            accordionItem: '.accordion-item',
            accordionButton: '.accordion-button',
            collapseContainer: '.accordion-collapse',
            buttonContainer: '.accordion-openclose-buttons',
            openButton: '.open-all',
            closeButton: '.close-all',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * initialize functions
     */
    init() {
        this.openCloseButtonFunction();
    }

    /**
     * On any click on the open/close-All buttons:
     * - adds or removes the class collapsed in the button of the headline container
     * - adds or removes the class show in the accordion-collapse container
     */
    openCloseButtonFunction() {
        const accordions = document.querySelectorAll(this.class.accordion);

        if (accordions.length > 0) {
            accordions.forEach((accordion) => {
                if (accordion.querySelector(this.class.buttonContainer)) {
                    accordion.querySelector(this.class.openButton).addEventListener('click', () => {
                        accordion.querySelectorAll(this.class.accordionItem).forEach((item) => {
                            if (!item.querySelector(this.class.collapseContainer).classList.contains('show')) {
                                item.querySelector(this.class.collapseContainer).classList.add('show');
                            }
                            if (item.querySelector(this.class.accordionButton).classList.contains('collapsed')) {
                                item.querySelector(this.class.accordionButton).classList.remove('collapsed');
                            }
                        });
                    });

                    accordion.querySelector(this.class.closeButton).addEventListener('click', () => {
                        accordion.querySelectorAll(this.class.accordionItem).forEach((item) => {
                            if (item.querySelector(this.class.collapseContainer).classList.contains('show')) {
                                item.querySelector(this.class.collapseContainer).classList.remove('show');
                            }
                            if (!item.querySelector(this.class.accordionButton).classList.contains('collapsed')) {
                                item.querySelector(this.class.accordionButton).classList.add('collapsed');
                            }
                        });
                    });
                }
            });
        }
    }
}

export default new Accordion();
